import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { ArchiveBoxIcon } from "@heroicons/react/20/solid";
import { PaymentStatus } from "@/gql/graphql";
import { DollarSignIcon } from "lucide-react";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { PaymentMarkPaidDialog } from "@/app/Payments/Components/PaymentMarkPaidDialog";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { deletePaymentMutation } from "@/app/Payments/GraphQL/paymentMutations";
import { PaymentListItem } from "@/app/Payments/GraphQL/paymentListQuery";

export function usePaymentActions(): ActionsHook<PaymentListItem> {
  const { open } = useDialog(PaymentMarkPaidDialog);
  const { mutateAsync: deletePayment } = useGqlMutation(deletePaymentMutation);
  const { isAdmin } = useTenant();

  return (model) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                isHidden: !isAdmin || model.status !== PaymentStatus.Unpaid,
                label: "Manually pay",
                Icon: DollarSignIcon,
                handleAction: () => {
                  open({
                    payment: model,
                  });
                },
              },
            ],
          },
          {
            actions: [
              {
                color: "red",
                isHiddenTopBar: true,
                isHidden: model.status === PaymentStatus.Unpaid,
                label: "Void",
                Icon: ArchiveBoxIcon,
                handleAction: () => {
                  alert("Void");
                },
              },
              {
                color: "red",
                isHiddenTopBar: true,
                isHidden: model.status !== PaymentStatus.Unpaid,
                label: "Delete",
                isAdminAction: true,
                Icon: TrashIcon,
                handleAction: async () => {
                  await deletePayment({
                    id: model.id,
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
